<template>
  <div class="hotel-search-page">
    <yetkidialog ref="yetkidialog" />
    <tanitimMail ref="tanitimdialog" :servisTipi="2" :providers="itemsproviders" />
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel" />
    <snackbarcomp v-bind:mesaj="snackText" v-model="snackbar" v-bind:color="snackColor" />

    <v-card flat class="page-card">
      <v-layout row wrap>
        <!-- Toolbar -->
        <v-flex xs12>
          <v-toolbar class="page-toolbar" dark>
            <v-toolbar-title class="page-title">{{ $t('Search-Hotel') || 'Otel Arama' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat class="supplier-btn" @click="dialogProviderAdd = true">
              <v-icon left>business</v-icon>
              <span class="hidden-sm-and-down">{{ $t('Supplier-Info') || 'Tedarikçi Bilgileri' }}</span>
            </v-btn>
          </v-toolbar>
        </v-flex>

        <!-- Hotel Search Component -->
        <v-flex xs12>
           <otelara v-if="sessionHeader.SessionId" :session-header="sessionHeader" @search="onSearch" />
        </v-flex>

        <!-- No Active Supplier Warning -->
        <v-flex xs12 pa-3 v-if="ActiveType === false">
          <v-alert type="warning" :value="true" outline class="supplier-alert">
            <v-layout align-center row>
              <v-flex>
                <span class="subheading font-weight-medium">{{ $t('supplier-warning') || 'Tedarikçi bulunamadı' }}</span>
              </v-flex>
            </v-layout>
          </v-alert>
        </v-flex>

        <!-- Empty Results – Hotel Provider Grid -->
        <v-flex xs12 pa-3 v-if="hotelList.length === 0">
          <v-card class="empty-results-card" elevation="1">
            <v-card-title primary-title class="pb-1">
              <div class="subheading grey--text text--darken-2">{{ $t('runner-v8') || 'Sistemler' }}</div>
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6 sm6 md3 pa-2 v-for="provider in hotelLogos" :key="provider.name">
                  <v-card class="airline-logo-card" :class="{
                    'airline-logo-card--active': provider.active,
                    'airline-logo-card--inactive': !provider.active
                  }" elevation="1">
                    <v-card-text class="airline-logo-content text-xs-center pa-3">
                      <img :src="provider.src" :alt="provider.name" class="airline-logo-img" />
                      <div v-if="!provider.active" class="coming-soon-badge">{{ $t('coming-soon') || 'Yakında' }}</div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions class="pa-3">
              <v-btn color="primary" block large elevation="2" class="contact-btn" @click="irtibatDialog">
                {{ $t('CONTACT-US') || 'İLETİŞİME GEÇİN' }}
                <v-icon right>contact_mail</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <!-- Search Results & Filters -->
        <v-flex xs12 pa-3 v-else>
          <v-layout row wrap>
            <!-- Filters Sidebar -->
            <v-flex xs12 md3 pr-3 class="mb-3">
              <v-card>
                <v-card-title class="title">{{ $t('Hotel-Filters') }}</v-card-title>
                <v-card-text>
                  <!-- Price Filter -->
                  <div class="subheading mt-2 mb-3 font-weight-bold">{{ $t('Hotel-Price-Range') }}</div>
                  <v-range-slider
                    v-model="priceRange"
                    :max="50000"
                    :min="0"
                    :step="100"
                    color="primary"
                    track-fill-color="primary"
                    hide-details
                    class="price-slider mt-2"
                  ></v-range-slider>
                  <v-layout row wrap justify-space-between class="mt-4">
                    <v-flex xs5 pr-1>
                      <v-text-field
                        v-model.number="priceRange[0]"
                        label="Min"
                        type="number"
                        prefix="₺"
                        hide-details
                        class="price-input"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 pl-1>
                      <v-text-field
                        v-model.number="priceRange[1]"
                        label="Max"
                        type="number"
                        prefix="₺"
                        hide-details
                        class="price-input"
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <!-- Star Filter -->
                  <div class="subheading mt-4 mb-3 font-weight-bold">{{ $t('Hotel-Star-Selection') }}</div>

                  <div class="caption grey--text mt-1 mb-2">{{ $t('Hotel-Min-Star') }}</div>
                  <v-rating
                    v-model="filters.MinStar"
                    :length="5"
                    color="amber"
                    background-color="grey lighten-3"
                    empty-icon="star_border"
                    full-icon="star"
                    hover
                    clearable
                    class="star-rating-large"
                  ></v-rating>

                  <div class="caption grey--text mt-4 mb-2">{{ $t('Hotel-Max-Star') }}</div>
                  <v-rating
                    v-model="filters.MaxStar"
                    :length="5"
                    color="amber"
                    background-color="grey lighten-3"
                    empty-icon="star_border"
                    full-icon="star"
                    hover
                    clearable
                    class="star-rating-large"
                  ></v-rating>

                  <!-- Hotel Services -->
                  <div v-if="availableFilters.HotelServicesList && availableFilters.HotelServicesList.length > 0">
                    <div class="subheading mt-3 mb-2 font-weight-bold">{{ $t('Hotel-Accommodation-Type') }}</div>
                    <v-checkbox
                      v-for="(service, index) in availableFilters.HotelServicesList"
                      :key="'service-' + index"
                      v-model="filters.HotelServiceList"
                      :label="service.FilterName"
                      :value="service"
                      hide-details
                      class="mt-1"
                    ></v-checkbox>
                  </div>

                  <!-- Hotel Properties -->
                  <div v-if="availableFilters.HotelPropertiesList && availableFilters.HotelPropertiesList.length > 0">
                    <div class="subheading mt-4 mb-2 font-weight-bold">{{ $t('Hotel-Facility-Features') }}</div>
                    <v-checkbox
                      v-for="(prop, index) in availableFilters.HotelPropertiesList"
                      :key="'prop-' + index"
                      v-model="filters.HotelPropertiesList"
                      :label="prop.FilterName"
                      :value="prop"
                      hide-details
                      class="mt-1"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="applyFilters" :loading="loadingvmodel">{{ $t('Hotel-Filter-Button') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <!-- Results Area -->
            <v-flex xs12 md9>
              <HotelResultCard
                v-for="hotel in hotelList"
                :key="hotel.HotelId"
                :hotel="hotel"
                :details="hotelDetails[hotel.HotelId] || {}"
                :loading-details="loadingRooms[hotel.HotelId] || false"
                :sessionHeader="sessionHeader"
                :searchParams="currentSearchParams"
                :searchId="searchId"
                @fetch-details="fetchRoomsForHotel"
                @error="showNotify"
              />
              <div class="text-xs-center mt-4" v-if="hotelList.length > 0 && totalPage > 1">
                <v-pagination v-model="pageNumber" :length="totalPage" @input="onPageChange" total-visible="7"></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-card>

    <ProviderAddDialog
      v-if="sessionHeader.SessionId"
      v-model="dialogProviderAdd"
      :sessionHeader="sessionHeader"
      :providers="itemsproviders"
      @notify="showNotify"
      @added="refreshProviders"
    />
  </div>
</template>

<script>
import yetkidialog from '@/components/app/customcomp/yetkidialog.vue';
import snackbarcomp from '@/components/app/customcomp/snackbarcomp.vue';
import loadingcomp from '@/components/app/customcomp/loadingcomp.vue';
import tanitimMail from '@/components/app/customcomp/tanitimMail.vue';
import helpers from '@/components/app/customcomp/helpers.js';
import hotelSearchService from './hotelSearchService';
import otelara from './otelara.vue';
import ProviderAddDialog from './ProviderAddDialog.vue';
import HotelResultCard from '@/components/hotel/HotelResultCard.vue';

export default {
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tanitimMail,
    otelara,
    ProviderAddDialog,
    HotelResultCard
  },

  data() {
    return {
      loadingvmodel: false,
      snackbar: false,
      snackColor: 'black',
      snackText: null,

      dialogProviderAdd: false,
      itemsproviders: [],
      hotelList: [],
      hotelDetails: {},
      loadingRooms: {},
      searchId: null,
      currentSearchParams: null,
      ActiveType: null,
      pageNumber: 1,
      totalPage: 1,

      availableFilters: {
        HotelPropertiesList: [],
        HotelServicesList: []
      },
      priceRange: [0, 50000],
      filters: {
        HotelPropertiesList: [],
        HotelServiceList: [],
        MinStar: 0,
        MaxStar: 5,
        MinPrice: 0,
        MaxPrice: 50000
      },

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      sessionHeader: { SessionId: null, SessionToken: null },
      firmaBilgileri: null,
      bookingUsername: '',
      bookingPassword: '',
    };
  },

  computed: {
    hotelLogos() {
      // Varsayılan otel sağlayıcıları (Mevcut assets dizininden logolar varsa buraya eklenebilir. Gerekirse placeholders konulur)
      return [
        { name: 'Paximum', src: require('@/assets/images/paximum.png'), active: true },
        // Gerekirse diğer sağlayıcılar buraya eklenebilir, şimdilik listeyeni.vue baz alınarak eklendi.
      ];
    }
  },

  watch: {
    priceRange(newVal) {
      this.filters.MinPrice = newVal[0];
      this.filters.MaxPrice = newVal[1];
    }
  },

  methods: {
    getCulture() {
      const cultureCodes = { 'tr': 'tr-TR', 'en': 'en-US', 'de': 'de-DE', 'fr': 'fr-FR' };
      const locale = this.$i18n.locale || 'tr';
      return cultureCodes[locale] || locale;
    },

    irtibatDialog() {
      if (this.$refs.tanitimdialog) {
        this.$refs.tanitimdialog.dialogtanitim = true;
      }
    },
    
    onPageChange(newPage) {
      if (this.currentSearchParams) {
        this.onSearch(this.currentSearchParams, newPage);
      }
    },
    
    async applyFilters() {
      if (this.currentSearchParams) {
        this.onSearch(this.currentSearchParams, 1, true);
      }
    },
    
    async onSearch(params, page = 1, isFilter = false) {
      this.currentSearchParams = params;
      this.pageNumber = page;
      this.loadingvmodel = true;
      
      if (!isFilter) {
        this.priceRange = [0, 50000];
        this.filters = {
          HotelPropertiesList: [],
          HotelServiceList: [],
          MinStar: 0,
          MaxStar: 5,
          MinPrice: 0,
          MaxPrice: 50000
        };
      }
      
      const passengers = params.rooms.map((room, index) => {
        return {
          RoomId: index + 1,
          Adt: room.adults,
          Child: room.children,
          ChildAge: room.children > 0 ? room.childAges : null
        };
      });

      const payload = {
        SearchId: null,
        SessionHeader: this.sessionHeader,
        LocationKey: params.location.LocationId,
        LocationType: params.location.HotelLocationType || params.location.HotelLocationType || "2",
        LocationName: params.location.Name || "",
        StartDate: params.startDate + 'T00:00:00',
        StartYear: params.startDate.split('-')[0],
        StartMonth: params.startDate.split('-')[1],
        StartDay: params.startDate.split('-')[2],
        Night: params.nights,
        EndDate: params.endDate + 'T00:00:00',
        PassengersInfo: passengers,
        MarkupType: params.markupType === 'Amount' ? 0 : 1,
        MarkupPrice: params.markupValue || 0,
        MinPrice: Number(this.filters.MinPrice) || 0.0,
        MaxPrice: Number(this.filters.MaxPrice) || 0.0,
        Language: "tr",
        SortType: null,
        CurrencyType: params.currency,
        NationalityType: params.nationality,
        HotelPropertiesList: this.filters.HotelPropertiesList || [],
        HotelServiceList: this.filters.HotelServiceList || [],
        RoomPropertiesList: [],
        Paging: {
          PageNumber: this.pageNumber,
          DataCount: 20,
          IsPageChanged: this.pageNumber > 1
        },
        LogInput: {
          UserID: 2,
          CustomerID: 1
        },
        RateId: null,
        MinStar: Number(this.filters.MinStar) || 0.0,
        MaxStar: Number(this.filters.MaxStar) || 0.0,
        Refoundble: 0,
        Stars: null,
        HotelName: "null",
        Bolge: null,
        AltBolge: null,
        IsSuggestedSearch: false,
        Culture: null,
        EmployeeID: 0
      };

      try {
        const culture = this.getCulture();
        const response = await hotelSearchService.searchHotels(this.$http, payload, culture);
        const data = response.data || response.body;
        
        if (data && !data.HasError && data.UniqueHotelList) {
          this.hotelList = data.UniqueHotelList;
          this.searchId = data.SearchId;
          this.totalPage = data.UniqueHotelList.length > 0 ? (data.UniqueHotelList[0].TotalPage || 1) : 1;
          this.hotelDetails = {};
          this.loadingRooms = {};
          
          if (!isFilter) {
            this.availableFilters.HotelPropertiesList = data.HotelPropertiesList || [];
            this.availableFilters.HotelServicesList = data.HotelServicesList || [];
          }
          
          // Scroll to top of the list if page changed
          if (this.pageNumber > 1) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        } else {
          this.hotelList = [];
          this.showError(data.ServiceError.ErrorMessages.join(" , "));
        }
      } catch (error) {
        console.error('Search API error:', error);
        this.hotelList = [];
        this.showError(this.$t('Hotel-Search-Error'));
      } finally {
        this.loadingvmodel = false;
      }
    },
    
    async fetchRoomsForHotel(hotelId) {
      if (this.loadingRooms[hotelId] || (this.hotelDetails[hotelId] && this.hotelDetails[hotelId].rooms && this.hotelDetails[hotelId].rooms.length > 0)) {
        return;
      }

      this.$set(this.loadingRooms, hotelId, true);
      
      const params = this.currentSearchParams;
      const passengers = params.rooms.map((room, index) => ({
        RoomId: index + 1,
        Adt: room.adults,
        Child: room.children,
        ChildAge: room.children > 0 ? room.childAges : null
      }));

      const payload = {
        SearchId: this.searchId,
        SessionHeader: this.sessionHeader,
        LocationKey: hotelId.toString(),
        LocationType: "2", // Using "2" as in user's prompt sample
        LocationName: "",
        StartDate: params.startDate + 'T00:00:00',
        StartYear: params.startDate.split('-')[0],
        StartMonth: params.startDate.split('-')[1],
        StartDay: params.startDate.split('-')[2],
        Night: params.nights,
        EndDate: params.endDate + 'T00:00:00',
        PassengersInfo: passengers,
        MarkupType: params.markupType === 'Amount' ? 0 : 1,
        MarkupPrice: params.markupValue || 0,
        MinPrice: 0.0,
        MaxPrice: 0.0,
        Language: "tr",
        SortType: null,
        CurrencyType: params.currency,
        NationalityType: params.nationality,
        HotelPropertiesList: [],
        HotelServiceList: [],
        RoomPropertiesList: [],
        Paging: {
          PageNumber: 1,
          DataCount: 20,
          IsPageChanged: false
        },
        LogInput: {
          UserID: 2,
          CustomerID: 1
        },
        RateId: hotelId,
        MinStar: 0.0,
        MaxStar: 0.0,
        Refoundble: 0,
        Stars: null,
        HotelName: null,
        Bolge: null,
        AltBolge: null,
        IsSuggestedSearch: true,
        Culture: null,
        EmployeeID: 0
      };

      const productInfoPayload = {
        SessionHeader: this.sessionHeader,
        HotelId: hotelId.toString(),
        Language: this.$i18n.locale || 'TR'
      };

      try {
        const culture = this.getCulture();
        const [roomsResponse, productInfoResponse] = await Promise.all([
          hotelSearchService.getHotelRooms(this.$http, payload, culture),
          hotelSearchService.getProductInfo(this.$http, productInfoPayload, culture)
        ]);

        const roomsData = roomsResponse.data || roomsResponse.body;
        const productData = productInfoResponse.data || productInfoResponse.body;
        
        let details = { rooms: [], hotelProperties: [], hotelServices: [], roomProperties: [], hotelImages: [], roomImages: [], description: '' };

        if (roomsData && !roomsData.HasError) {
          details.rooms = (roomsData.HotelSearchResponse && roomsData.HotelSearchResponse.PriceResults) ? roomsData.HotelSearchResponse.PriceResults : [];
        }

        if (productData && !productData.HasError) {
          details.hotelProperties = productData.HotelPropertyList || productData.HotelPropertiesList || [];
          details.hotelServices = productData.HotelServiceList || productData.HotelServicesList || [];
          details.roomProperties = productData.RoomPropertyList || productData.RoomPropertiesList || [];
          details.hotelImages = productData.HotelImageList || [];
          details.roomImages = productData.RoomImageList || [];
          details.description = productData.Description || '';
        }
        
        this.$set(this.hotelDetails, hotelId, details);
      } catch (error) {
        console.error("Oda getirme hatası", error);
        this.$set(this.hotelDetails, hotelId, { rooms: [], hotelProperties: [], hotelServices: [], roomProperties: [], hotelImages: [], roomImages: [] });
      } finally {
        this.$set(this.loadingRooms, hotelId, false);
      }
    },

    showNotify({ type, message }) {
      this.snackColor = type === 'success' ? 'success' : 'error';
      this.snackText = message;
      this.snackbar = true;
    },

    showError(message = 'İşlem başarısız oldu') {
      this.loadingvmodel = false;
      this.showNotify({ type: 'error', message });
    },

    async BookingKontrol() {
      const firmaOk = await this.firmaBilgileriGetir();
      if (!firmaOk) return;

      const ekUrunOk = await this.ekUrunGetir();
      if (!ekUrunOk) return;

      const agencyExists = await this.chkAgency();
      if (!agencyExists) {
        const added = await this.addAgency();
        if (!added) return;
      }

      await this.login();
    },

    async firmaBilgileriGetir() {
      this.loadingvmodel = true;
      try {
        const credentials = JSON.parse(localStorage.getItem('credentials') || '{}');
        const resp = await hotelSearchService.getCompany(this.$http, credentials.SirketKodu);

        this.firmaBilgileri = {
          Name: credentials.CoperSirketAdi,
          City: resp.body.Il,
          District: resp.body.Ilce,
          Address: resp.body.Adres,
          Gsm: resp.body.Tel,
          Email: resp.body.Email,
          TaxOffice: resp.body.VergiDairesi,
          TaxNo: resp.body.VergiNo
        };

        if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
          this.showNotify({ type: 'error', message: this.$t('Hotel-Provider-Info-Not-Found') });
          return false;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Provider-Info-Not-Found') });
        return false;
      }
    },

    async ekUrunGetir() {
      this.loadingvmodel = true;
      try {
        const resp = await hotelSearchService.checkExtraProduct(this.$http);
        const aktif = resp.body[3] && resp.body[3].Aktif;
        if (!aktif) {
          this.showNotify({ type: 'error', message: this.$t('Hotel-Provider-Info-Not-Found') });
          return false;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Provider-Info-Not-Found') });
        return false;
      }
    },

    async chkAgency() {
      this.loadingvmodel = true;
      try {
        const resp = await hotelSearchService.checkAgency(
          this.$http,
          this.firmaBilgileri.Email,
          this.firmaBilgileri.TaxNo
        );
        if (resp.body.HasError) {
          this.loadingvmodel = false;
          return false;
        }
        this.bookingUsername = resp.body.Username;
        this.bookingPassword = resp.body.Password;
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Agency-Check-Failed') });
        return false;
      }
    },

    async addAgency() {
      this.loadingvmodel = true;
      try {
        const resp = await hotelSearchService.addAgency(this.$http, this.firmaBilgileri);
        if (resp.body.Username) {
          this.bookingUsername = resp.body.Username;
          this.bookingPassword = resp.body.Password;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Agency-Add-Failed') });
        return false;
      }
    },

    async refreshProviders() {
      try {
        const resp = await hotelSearchService.getCredentials(this.$http, this.sessionHeader);
        const creds = (resp.body && resp.body.Credentials) || [];
        this.itemsproviders = creds
          .filter(c => c.ProviderType === 'Hotel')
          .map(c => ({
            Id: c.Id,
            Provider: c.Provider,
            ProviderType: c.ProviderType,
            ServiceUsername: c.ServiceUsername,
            ServicePassword: c.ServicePassword,
            ServiceSecurityKey: c.ServiceSecurityKey,
            OfficeId: c.OfficeId,
            url: c.Address
          }));
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Provider-Info-Not-Found') });
      }
    },

    async login() {
      this.loadingvmodel = true;
      try {
        const resp = await hotelSearchService.login(this.$http, this.bookingUsername, this.bookingPassword);
        this.sessionHeader = {
          SessionId: resp.body.SessionId,
          SessionToken: resp.body.SessionToken
        };
        localStorage.setItem('hotelBookingParams', JSON.stringify(resp.body));
        await this.refreshProviders();
        this.loadingvmodel = false;
      } catch {
        this.showNotify({ type: 'error', message: this.$t('Hotel-Login-Failed') });
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => { vm.prevRoute = from.path; });
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

      this.BookingKontrol();
    
  }
};
</script>

<style scoped>
/* ── Page ─────────────────────────────────────── */
.hotel-search-page {
  background: #ffffff;
  min-height: 100vh;
}

.page-card {
  background: #ffffff !important;
}

/* ── Toolbar ──────────────────────────────────── */
.page-toolbar {
  background: linear-gradient(135deg, #1976D2, #1565C0) !important;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.35) !important;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
}

.supplier-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  transition: background 0.2s ease;
}

.supplier-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}

/* ── Supplier Warning ─────────────────────────── */
.supplier-alert {
  border-radius: 10px !important;
  font-size: 15px;
}

/* ── Empty Results Card ───────────────────────── */
.empty-results-card {
  border-radius: 12px !important;
}

/* ── Logo Cards ───────────────────────── */
.airline-logo-card {
  border-radius: 12px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
}

.airline-logo-card:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14) !important;
}

.airline-logo-card--active {
  border: 2px solid #43A047;
}

.airline-logo-card--inactive {
  border: 2px solid #e0e0e0;
  opacity: 0.75;
}

.airline-logo-content {
  min-height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.airline-logo-img {
  max-height: 50px;
  max-width: 80%;
  object-fit: contain;
}

/* ── Coming Soon Badge ────────────────────────── */
.coming-soon-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #FF9800;
  color: #ffffff;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 10px;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

/* ── Contact Button ───────────────────────────── */
.contact-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-size: 15px;
  font-weight: 500;
}

/* ── Price Slider ─────────────────────────── */
.price-slider {
  margin: 12px 0;
}

.price-slider ::v-deep .v-slider__track-fill {
  background: linear-gradient(90deg, #1976D2, #42A5F5) !important;
}

.price-input {
  border-radius: 6px !important;
}

.price-input ::v-deep .v-text-field__slot input {
  font-size: 14px;
  font-weight: 500;
}

/* ── Star Rating ──────────────────────────── */
.star-rating-large {
  display: flex;
  gap: 8px;
}

.star-rating-large ::v-deep .v-icon {
  font-size: 32px !important;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.star-rating-large ::v-deep .v-icon:hover {
  transform: scale(1.15);
  filter: brightness(1.1);
}

.star-rating-large ::v-deep i.v-icon {
  color: #FFC107 !important;
}
</style>
